import React from 'react';
import compose from 'recompose/compose';
import renderNothing from 'recompose/renderNothing';
import branch from 'recompose/branch';
import { connect } from 'react-redux';
import get from 'lodash.get';
import ExtraUserInformationFormModal from './ExtraUserInformationFormModal';
import styles from './ExtraUserInformation.css';
import UbeuAdditionalInformationFields from './UbeuAdditionalInformationFields';

const UbeuExtraInformation = ({ ...props }) => (<ExtraUserInformationFormModal
    title="Welcome to uBEu!"
    subtitle="Please provide some additional information below to continue."
    {...props}
>
    <UbeuAdditionalInformationFields />
    <p className={styles.info}>
        {'By creating a user account, I give consent to be contacted by mail, email and telephone (including auto-dialed, prerecorded and/or text messaging) to the designated number and contact information I have provided to receive information on prospective schools, partners and other organizations. I also give consent to share my workshop information with my high school teachers and/or counselors. Standard messaging and data rates may apply based on the plan you have with your mobile carrier. This consent does not require you to make a purchase.'}
    </p>
</ExtraUserInformationFormModal>);

export default compose(
    connect(({ me, auth }) => ({
        show: (me && (!me.graduationYear
                || !me.streetAddress
                || !me.zip
                || !me.state
        ) && Number(auth.level) === 5),
        initialValues: {
            mobilePhone: get(me, 'mobilePhone'),
            graduationYear: get(me, 'graduationYear'),
            streetAddress: get(me, 'streetAddress'),
            unit: get(me, 'unit'),
            city: get(me, 'city'),
            state: get(me, 'state'),
            zip: get(me, 'zip'),
        },
    })),
    branch(
        ({ show }) => !show,
        renderNothing,
    ),
)(UbeuExtraInformation);



// WEBPACK FOOTER //
// ./src/client/Components/ExtraUserInformation/UbeuExtraInformation.js